import { RouteObject } from 'react-router-dom';
import { FleetReporting } from '../FleetReporting';

export const ReportingDashboardRoutes: RouteObject[] = [
  {
    path: 'dashboard',
    element: <FleetReporting />,
  },
];
